import { FileQuestion, Home, ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'

export function NotFoundPage() {
  const navigate = useNavigate()

  const handleGoHome = () => {
    // Chat is home.
    navigate('/chat')
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-4" data-testid="not-found-page">
      <Card className="w-full max-w-[28rem]">
        <CardHeader className="text-center">
          <div className="bg-primary/10 mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            <FileQuestion className="text-primary h-8 w-8" />
          </div>
          <CardTitle className="text-primary text-6xl font-bold">404</CardTitle>
          <CardDescription className="mt-2 text-lg">Page Not Found</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4 text-center">
          <p className="text-muted-foreground">
            The page you're looking for doesn't exist or has been moved.
          </p>
          <div className="flex flex-col gap-3">
            <Button onClick={handleGoHome} className="w-full" data-testid="not-found-home-button">
              <Home className="mr-2 h-4 w-4" />
              Go to Chat
            </Button>
            <Button
              variant="outline"
              onClick={handleGoBack}
              className="w-full"
              data-testid="not-found-back-button"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
